<template>
    <el-row>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>配货商品</span>
                <el-button v-if="type === 'add'" style="float: right;" size="mini" @click="openDialog">添加商品</el-button>
            </div>
            <el-table
                :data="tableData"
                v-loading="loading"
                border
                style="width: 100%"
                class="elTable">
                <el-table-column
                    align="center"
                    type="index"
                    label="序号"
                    width="50">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="barCode"
                    label="69码"
                    width="150">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="skuCode"
                    label="SKU"
                    width="100">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="skuName"
                    label="商品名称"
                    min-width="300">
                    <template slot-scope="scope">{{filterStr(scope.row.skuName)}}</template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="availableInventory"
                    label="当前可用库存">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="passageInventory"
                    label="在途库存">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="storeInventory"
                    label="门店库存">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="weekSell"
                    label="平均周销">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="suggestGoods"
                    label="建议配货量">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="stayGoods"
                    label="待审批配货量">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="practicalGoods"
                    :label="typeWaybillMode">
                    <template slot-scope="scope">
                        <el-input v-if="type === 'add'" v-model.trim="scope.row.practicalGoods"
                                  placeholder="配货量" @keyup.native="upNumber($event)" required="required"
                                  @blur="upNumber($event)"></el-input>
                        <span v-else>{{ scope.row.practicalGoods }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="approveGoods"
                    label="审批数量"
                    v-if="type == 'edit'">
                    <template slot-scope="scope">
                        <el-input v-if="type === 'edit'" v-model.trim="scope.row.approveGoods"
                                  placeholder="配货量" @keyup.native="upNumber($event)"
                                  @blur="upNumber($event,scope.row.approveGoods)"></el-input>
                        <span v-else>{{ scope.row.approveGoods }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="approveGoods"
                    label="审批数量"
                    v-if="type != 'edit'&& type != 'add'"
                    >
                    <template slot-scope="scope">
                        <span>{{ scope.row.approveGoods }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="type === 'add'"
                    fixed="right"
                    label="操作"
                    width="100"
                    align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="godetail(scope.row.barCode,type)">查看</el-button>
                        <el-button type="text" @click="removeGoods(scope.$index)">删除</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="type === 'edit'"
                    fixed="right"
                    label="操作"
                    width="100"
                    align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="godetail(scope.row.barCode,type)">查询库存</el-button>
                    </template>
                </el-table-column>
<!--                <el-table-column-->
<!--                    v-if="type === 'edit'"-->
<!--                    fixed="right"-->
<!--                    label="操作"-->
<!--                    width="70"-->
<!--                    align="center">-->
<!--                    <template slot-scope="scope">-->
<!--                        <el-button type="text" @click="godetail(scope.row.barCode,type)">查看</el-button>-->
<!--                    </template>-->
<!--                </el-table-column>-->
            </el-table>
        </el-card>
        <dialog-goods-list ref="dialogGoodsList" :client="client" :goods-list="tableData"></dialog-goods-list>
    </el-row>
</template>

<script>
import {getPrepareList} from "@/modules/server-api/prepare/prepare";
import dialogGoodsList from "./dialogGoodsList";

export default {
    name: "goodsList",
    components: {dialogGoodsList},
    props: {
        type: {
            type: String,
        },
        data: {
            type: Object,
            default: () => ({})
        },
        client:{
            type: Object,
            default: () => ({})
        },
        orderInfo:{
            type: Object,
            default: () => ({})
        },
        typeWaybillMode:{
            type:String,
            default: "主动配货量"
        }
    },
    data() {
        return {
            tableData: [],
            loading: true,
            // typeWaybillMode:''//判断状态
        }
    },
    created(){
        // console.log(888)
        // let string = this.orderInfo.waybillMode.toString()
        //  console.log('this.orderInfo.waybillMode',string)
        // this.typeWaybillMode = string == '主动配货' ? '主动配货量' : '门店要货量'
        // console.log('this.orderInfo.waybillMode',this.typeWaybillMode)
    },
    mounted() {
        if (this.type === 'add') {
            this.loading = false;
        }
    },
    methods: {
        openDialog(){
            this.$refs.dialogGoodsList.open();
        },
        async getPriceDetailList() {
            //根据入库单获取商品
            let rep = await getPrepareList.getPriceDetailList({
                orderNo: this.data.orderNo
            });
            console.log(rep);
            if (rep.succ === 1) {
                let resList = rep.result.goodsList;
                this.tableData = resList.map(item => {
                    console.log('item', item)
                    return item;
                });
                console.log('this.tableData',this.tableData)
            }
        },
        addGoods(data) {
            // console.log('888888',data)
            this.tableData = data.map(item =>{
                // console.log( 'item', item );
                if ( item.availableAmount ){
                    item.availableInventory = item.availableAmount ;
                }else {
                    item.availableInventory = item.availableInventory ? item.availableInventory : 0;
                }
                item.passageInventory= item.passageInventory ? item.passageInventory:0;
                item.storeInventory= item.storeInventory?item.storeInventory:0;
                item.weekSell=item.weekSell?item.weekSell:0;
                item.suggestGoods=item.suggestGoods?item.suggestGoods:0;
                item.stayGoods=item.stayGoods?item.stayGoods:0;
                item.categoryName = item.categoryName?item.categoryName:item.goodsCategoryName;
                return item;
            });
            // console.log('this.tableData',this.tableData)
            this.loading = false;
        },
        getGoods(){

          return this.tableData;

        },
        removeGoods(index) {
            this.tableData.splice(index, 1)
        },
        //获取详情信息
        async godetail(categoryCode,type){
            // console.log('this.orderInfo.storeCode',this.orderInfo)
            type = type=='add' ? this.orderInfo.value : this.orderInfo.storeCode



            let res = await getPrepareList.getDetail({
                'pageNum':1,
                'pageSize':20,
                'skuCode':[categoryCode],
                'shopCode':type,
                'whareTypeCode':'1'
            })
            if(res.result.succ == 0){
                this.$notifyError(res.result.error);
            }else{
                let result = res.result.result;
                console.log('result',result)
                this.tableData.map(item => {
                    if(item.barCode == categoryCode) {
                        item.availableInventory = result.availableInventory||'0',
                        item.passageInventory = result.passageInventory||'0',
                        item.storeInventory = result.storeInventory||'0',
                        item.weekSell = result.weekSell||'0',
                        item.suggestGoods = result.suggestGoods||'0',
                        item.stayGoods = result.stayGoods||'0',
                        item.approveGoods = result.approveGoods||'0'
                        // item.practicalGoods = result.practicalGoods||'0'
                    }
                })
            }
        },
        upNumber(e,row){
            // 正整数--包括0
            // e.target.value = e.target.value.replace(/[^\d]/g,'')
            // 正整数--不包括0
            // e.target.value = e.target.value.replace(/^(0+)|[^\d]+/g,'')
            console.log('231',e.target.value,row);
            // 可以输入0，但是不能有0开头的数
            var patrn=/^([1-9]\d*|0)(\.\d*[1-9])?$/
            if (!patrn.exec(e.target.value))
            {
             e.target.value = ''
            }
                // else{
                // // alert("错误");
                // // e.target.value = ''
                // }
            // this.tableData.approveGoods = e.target.value || ''
            // console.log('555',this.tableData.approveGoods)
        //    let flag = new RegExp("^[1-9]([0-9])*$").test(e.target.value);
            //    console.log(flag);
        //        if (!flag) {
        //            this.$message({
        //                showClose:true,
        //                message:"请输入正整数",
        //                type:"warning"
        //                });
        //             }
        }
    },
}
</script>

<style scoped>

</style>
